import React from 'react'

interface RadioDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const RadioDT: React.FC<RadioDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M9.97493 18.3346C14.5773 18.3346 18.3083 14.6037 18.3083 10.0013C18.3083 5.39893 14.5773 1.66797 9.97493 1.66797C5.37256 1.66797 1.6416 5.39893 1.6416 10.0013C1.6416 14.6037 5.37256 18.3346 9.97493 18.3346Z" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.99961 13.5246C11.9464 13.5246 13.5246 11.9464 13.5246 9.99961C13.5246 8.05281 11.9464 6.47461 9.99961 6.47461C8.05281 6.47461 6.47461 8.05281 6.47461 9.99961C6.47461 11.9464 8.05281 13.5246 9.99961 13.5246Z" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default RadioDT
